<template>
  <nav v-if="hasCrumbs" class="py-11" aria-label="breadcrumbs">
    <div class="breadcrumb page-wrapper whitespace-nowrap">
      <ol class="flex flex-row list-none p-0 m-0 flex-wrap">
        <li v-for="(crumb, index) in crumbs" :key="crumb.path">
          <NuxtLink
            v-if="!isLastCrumb(index)"
            :to="crumb.path"
            external
            class="no-underline standalone"
            :aria-label="crumb.aria"
          >
            <span
              v-if="isNotFirstCrumb(index)"
              class="text-border-success font-medium pr-4"
              aria-hidden="true"
            >
              /
            </span>
            <span
              class="text-text-link body-link-md pr-8 underline hover:text-text-link-hover"
            >
              {{ crumb.name }}
            </span>
          </NuxtLink>

          <NuxtLink
            v-if="isLastCrumb(index)"
            to="#"
            class="heading-xxs no-underline cursor-default standalone"
            aria-current="page"
          >
            <span
              v-if="isNotFirstCrumb(index)"
              class="text-border-success font-medium pr-4"
              aria-hidden="true"
            >
              /
            </span>
            <span class="text-text-primary heading-xxs pr-8">
              {{ crumb.name }}
            </span>
          </NuxtLink>
        </li>
      </ol>
    </div>
  </nav>
</template>

<script lang="ts" setup>
const route = useRoute();

interface Props {
  pageName?: string;
}

const props = withDefaults(defineProps<Props>(), {
  pageName: '',
});

const crumbs = computed(() => {
  let fullPath = route.fullPath.split('?')[0];
  fullPath = fullPath.split('#')[0];

  const initialCrumbs = breadcrumbs_initiateBreadcrumbsList();
  const restOfCrumbs = breadcrumbs_buildBreadcrumbsListFromPath(fullPath);
  let crumbs = initialCrumbs.concat(restOfCrumbs);

  crumbs = breadcrumbs_cleanOutShop(crumbs);
  crumbs = breadcrumbs_capitalizeCrumbs(crumbs);
  crumbs = breadcrumbs_replaceNamesWithPresentableOnes(crumbs);

  if (props.pageName) {
    crumbs = breadcrumbs_setPageNameOnLastCrumb(props.pageName, crumbs);
  }

  return crumbs;
});

const hasCrumbs = crumbs.value.length > 1;

const isLastCrumb = (index: number): boolean =>
  index === crumbs.value.length - 1;

const isNotFirstCrumb = (index: number): boolean => index > 0;
</script>

<style scoped lang="scss"></style>
